import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.1333 0.920898L16.031 2.1055C16.0198 2.23508 16.0141 2.36645 16.0141 2.49939C16.0141 4.98797 18.0315 7.00536 20.5201 7.00536C20.653 7.00536 20.7844 6.99963 20.914 6.98845L22.0986 6.88616L21.9963 8.07076C21.8488 9.7793 21.0419 11.2971 19.8336 12.3704C20.5729 13.2765 21.0195 14.4252 21.0195 15.6805C21.0195 18.6638 18.519 21.0185 15.5147 21.0185H5.60391C3.09715 21.0185 1 19.0522 1 16.5481C1 14.7164 2.12578 13.1695 3.70861 12.4734C3.70484 12.386 3.70293 12.2982 3.70293 12.21C3.70293 9.06341 6.1015 6.51059 9.1673 6.07126C9.78028 3.34598 12.1017 1.26901 14.9487 1.02318L16.1333 0.920898ZM10.1088 8.00437C10.0874 8.00437 10.066 8.00452 10.0446 8.00481C7.60588 8.0379 5.70293 9.94228 5.70293 12.21C5.70293 12.4726 5.72801 12.7286 5.77576 12.9765L5.95986 13.9319L5.00979 14.1421C3.83284 14.4024 3 15.4033 3 16.5481C3 17.8772 4.1299 19.0185 5.60391 19.0185H15.5147C17.4863 19.0185 19.0195 17.4888 19.0195 15.6805C19.0195 14.628 18.5078 13.6794 17.6867 13.0607C17.557 12.963 17.4199 12.8738 17.2761 12.794C16.7608 12.5078 16.1602 12.3424 15.5147 12.3424C15.4949 12.3424 15.4753 12.3426 15.4557 12.3429L14.6014 12.3562L14.4548 11.5145C14.1722 9.89101 12.9017 8.55454 11.2163 8.13818C10.8636 8.05104 10.4927 8.00437 10.1088 8.00437Z"}}]};

const CloudyNightFilled = Vue.extend<IconProps>({
  name: 'CloudyNightFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'cloudy-night-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CloudyNightFilled;
